/**
 * Application Entry Point
 * Initializes Master Engine, HUD, Audio Graph, and Lifecycle.
 */

import { Engine } from './core/Engine';
import { HUD } from './ui/HUD';
import { TerminalModal } from './ui/TerminalModal';

window.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('app-canvas') as HTMLCanvasElement;
  if (!canvas) {
    console.error('Canvas element #app-canvas not found.');
    return;
  }

  // 1. Initialize Engine
  const engine = Engine.getInstance();
  engine.init(canvas);

  // 2. Initialize HUD & UI Modals
  const hud = new HUD();
  hud.init();

  const terminalModal = new TerminalModal();
  terminalModal.init();

  // 3. Start 120Hz Loop
  engine.start();

  // 4. Audio Context Unlock on User Interaction
  const unlockAudio = () => {
    engine.getAudioSystem().init();
    window.removeEventListener('pointerdown', unlockAudio);
    window.removeEventListener('keydown', unlockAudio);
  };
  window.addEventListener('pointerdown', unlockAudio);
  window.addEventListener('keydown', unlockAudio);
});
